import { render, staticRenderFns } from "./ModalFAQ.vue?vue&type=template&id=011de548&scoped=true"
import script from "./ModalFAQ.vue?vue&type=script&lang=js"
export * from "./ModalFAQ.vue?vue&type=script&lang=js"
import style0 from "./ModalFAQ.vue?vue&type=style&index=0&id=011de548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011de548",
  null
  
)

export default component.exports